/**
 * お知らせ
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'
import {ADMIN_NOTIFICATION_RESET_CONDITION, ADMIN_NOTIFICATION_RESET_PAGINATION} from "../../mutation-types/admin-types";

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/notifications`


const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      title: null,
      use_important: false
    },
  }
}

const notification = {
  namespaced: true,
    state: getDefaultState(),
    getters: {
      hasResult: ( state ) => {
        return (state.pagination.total_count > 0)
      },
    },
    actions: {
       index ({ dispatch, commit, state }, { title, use_important, page }) {
        dispatch('saveCondition', { title: title, use_important: use_important })
        const params = {
          title: state.condition.title,
          use_important: state.condition.use_important,
          page: page 
        }
        return new Promise((resolve) => {
          Vue.$http.get(API_PATH, { params: params }).then(data => {
            let content = data.content
            commit(types.ADMIN_NOTIFICATION, { content })
            resolve(data.content)
          })
        })
      },
      show ({ commit }, { id }) {
        const api_path = `${API_PATH}/${id}`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            commit
            resolve(data.content)
          })
        })
      },
      new () {
        const api_path = `${API_PATH}/new`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            resolve(data.content)
          })
        })
      },
      create ({ commit }, { params }) {
        return new Promise( ( resolve ) => {
          Vue.$http.post(API_PATH, params).then( data => {
            let content = data.content
            commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
            resolve(content)
          } )
        })

      },
      edit ({ commit }, { id }) {
        const api_path = `${API_PATH}/${id}/edit`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            commit
            resolve(data.content)
          })
        })
      },
      update ({ commit },{ id, params }) {
        const api_path = `${API_PATH}/${id}`
        return new Promise( ( resolve ) => {
          Vue.$http.put(api_path, params).then( data => {
            let content = data.content
            commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
            resolve(content)
          } )
        })
      },
      destroy ({ commit }, { id }) {
        const api_path = `${API_PATH}/${id}`
        return new Promise( ( resolve ) => {
          Vue.$http.delete(api_path).then(data => {
            commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
            resolve(data.content)
          })
        })
      },
      saveCondition ({ commit, state }, { title, use_important }) {
        const _title = (title !== undefined) ? title : state.condition.title
        const _use_important = (use_important !== undefined) ? use_important : state.condition.use_important
        const params = { 
          title: _title,
          use_important: _use_important,
        }
        commit(types.ADMIN_NOTIFICATION_CONDITION, { params })
      },
      resetState ({ commit }) {
        commit(types.ADMIN_NOTIFICATION_RESET_CONDITION)
      },
      resetPagination ({ commit }) {
        commit(types.ADMIN_NOTIFICATION_RESET_PAGINATION)
      },
    },
    mutations: {
      [types.ADMIN_NOTIFICATION_RESET_PAGINATION] ( state ) {
        Object.assign(state.pagination, getDefaultState().pagination)
      },
      [types.ADMIN_NOTIFICATION_RESET_CONDITION] (state) {
        Object.assign(state, getDefaultState())
      },
      [types.ADMIN_NOTIFICATION] (state, { content }) {
        state.pagination = content.pagination
      },
      [types.ADMIN_NOTIFICATION_CONDITION] (state, { params }) {
        state.condition.title = params.title,
        state.condition.use_important = params.use_important
      }
    },
}

export default notification

